import { useQuery } from "@tanstack/react-query";

import { createSavedSearchQuery } from "./options";

export const useSingleSavedSearch = (savedSearchId: string | null) => {
    return useQuery({
        enabled: !!savedSearchId,
        ...createSavedSearchQuery(savedSearchId),
    });
};
